import React from 'react';
import './inicio.css';

const Servicios = () => {
    return (
        <section className="servicios-section py-5">
            <div className="container">
                <h1 className="text-center mb-4 text-success">Nuestros Servicios</h1>
                <div className="row justify-content-center">
                    {/* Análisis Holísticos de Seguridad */}
                    <div className="col-md-6 mb-4">
                        <div className="servicio-card">
                            <div className="card-content">
                                <div className="icon-container">
                                    <i className="bi bi-shield-lock-fill"></i>
                                </div>
                                <h3>Análisis Holísticos de Seguridad</h3>
                                <p>Evaluación integral de la seguridad considerando factores tecnológicos y humanos.</p>
                                <div className="card-features">
                                    <ul>
                                        <li><i className="bi bi-check-circle"></i> Pruebas de Penetración</li>
                                        <li><i className="bi bi-check-circle"></i> Ethical Hacking de Aplicaciones Móviles</li>
                                        <li><i className="bi bi-check-circle"></i> Revisión de Código Fuente</li>
                                        <li><i className="bi bi-check-circle"></i> Servicios de Red Team</li>
                                        <li><i className="bi bi-check-circle"></i> Auditoría de Contratos Inteligentes y Blockchain</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Respuesta de Incidentes y Análisis Forense */}
                    <div className="col-md-6 mb-4">
                        <div className="servicio-card">
                            <div className="card-content">
                                <div className="icon-container">
                                    <i className="bi bi-bug-fill"></i>
                                </div>
                                <h3>Respuesta de Incidentes y Análisis Forense</h3>
                                <p>Identificación, contención e investigación de incidentes de seguridad.</p>
                                <div className="card-features">
                                    <ul>
                                        <li><i className="bi bi-check-circle"></i> Búsqueda e Identificación de Amenazas y Compromiso</li>
                                        <li><i className="bi bi-check-circle"></i> Respuesta a Incidentes y Forense</li>
                                        <li><i className="bi bi-check-circle"></i> Análisis de Amenazas</li>
                                        <li><i className="bi bi-check-circle"></i> Controles de Seguridad</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Consultoría en Ciberseguridad */}
                    <div className="col-md-6 mb-4">
                        <div className="servicio-card">
                            <div className="card-content">
                                <div className="icon-container">
                                    <i className="bi bi-briefcase-fill"></i>
                                </div>
                                <h3>Consultoría en Ciberseguridad</h3>
                                <p>Asesoramiento estratégico para alinear la seguridad con los objetivos empresariales.</p>
                                <div className="card-features">
                                    <ul>
                                        <li><i className="bi bi-check-circle"></i> Asesoría Estratégica</li>
                                        <li><i className="bi bi-check-circle"></i> Fortalecimiento del Negocio</li>
                                        <li><i className="bi bi-check-circle"></i> Consultoría y Evaluación de SWIFT CSP</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Formación en Ciberseguridad */}
                    <div className="col-md-6 mb-4">
                        <div className="servicio-card">
                            <div className="card-content">
                                <div className="icon-container">
                                    <i className="bi bi-person-lines-fill"></i>
                                </div>
                                <h3>Formación en Ciberseguridad</h3>
                                <p>Capacitación personalizada para fortalecer la cultura de seguridad en la organización.</p>
                                <div className="card-features">
                                    <ul>
                                        <li><i className="bi bi-check-circle"></i> Capacitación Interna</li>
                                        <li><i className="bi bi-check-circle"></i> Workshops</li>
                                        <li><i className="bi bi-check-circle"></i> Soluciones Personalizadas</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Servicios;